const state = {
    pitchAngle: 'not-very-steep', // not-very-steep, steeper, very-steep
    pitchAngleHover: null,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  setPitchAngle(state, pitchAngle) {
    state.pitchAngle = pitchAngle
  },
  setPitchAngleHover(state, pitchAngleHover) {
    state.pitchAngleHover = pitchAngleHover
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}